(() => {
  const pageSize = 12;

  function initialiseGallery(gallery) {
    if (gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';

    const grid = gallery.querySelector('[data-card-grid]');
    document.querySelectorAll('[data-extra-cake-cards] [data-cake-card]').forEach((card) => {
      grid.append(card.cloneNode(true));
    });
    const cards = Array.from(gallery.querySelectorAll('[data-cake-card]'));
    const filters = Array.from(gallery.querySelectorAll('[data-filter]'));
    const status = gallery.querySelector('[data-showing-status]');
    const moreButton = gallery.querySelector('[data-load-more]');
    const dialog = gallery.querySelector('[data-design-dialog]');
    let activeFilter = 'all';
    let visibleCount = pageSize;
    let activeCard = null;

    const matchingCards = () => cards.filter((card) => activeFilter === 'all' || card.dataset.category === activeFilter);

    filters.forEach((button) => {
      const count = button.querySelector('[data-count]');
      if (count) count.textContent = button.dataset.filter === 'all'
        ? cards.length
        : cards.filter((card) => card.dataset.category === button.dataset.filter).length;
    });

    function updateGrid() {
      const matching = matchingCards();
      cards.forEach((card) => { card.hidden = true; });
      matching.slice(0, visibleCount).forEach((card) => { card.hidden = false; });
      const shown = Math.min(visibleCount, matching.length);
      status.textContent = `Showing ${shown} of ${matching.length} designs`;
      moreButton.hidden = shown >= matching.length;
    }

    function displayCard(card) {
      if (!card) return;
      activeCard = card;
      const image = dialog.querySelector('[data-modal-image]');
      image.src = card.dataset.image;
      image.alt = `${card.dataset.name} — ${card.dataset.label}`;
      dialog.querySelector('[data-modal-category]').textContent = card.dataset.label;
      dialog.querySelector('[data-modal-title]').textContent = card.dataset.name;
      dialog.querySelector('[data-modal-label]').textContent = card.dataset.label;
      dialog.querySelector('[data-modal-code]').textContent = card.dataset.code;
      dialog.querySelector('[data-modal-original]').href = card.dataset.original;
      dialog.querySelector('[data-modal-enquiry]').href = card.dataset.enquiry;
    }

    function movePreview(direction) {
      const matching = matchingCards();
      if (!matching.length || !activeCard) return;
      const position = matching.indexOf(activeCard);
      const next = (position + direction + matching.length) % matching.length;
      displayCard(matching[next]);
    }

    gallery.addEventListener('click', (event) => {
      const filter = event.target.closest('[data-filter]');
      if (filter && gallery.contains(filter)) {
        activeFilter = filter.dataset.filter;
        visibleCount = pageSize;
        filters.forEach((button) => {
          const selected = button === filter;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        updateGrid();
        return;
      }

      if (event.target.closest('[data-load-more]')) {
        visibleCount += pageSize;
        updateGrid();
        return;
      }

      const trigger = event.target.closest('[data-open-design]');
      if (trigger) {
        const card = trigger.closest('[data-cake-card]');
        displayCard(card);
        if (!dialog.open) dialog.showModal();
        return;
      }

      if (event.target.closest('[data-modal-close]')) dialog.close();
      if (event.target.closest('[data-modal-previous]')) movePreview(-1);
      if (event.target.closest('[data-modal-next]')) movePreview(1);
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); movePreview(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); movePreview(1); }
    });
    dialog.addEventListener('close', () => { activeCard = null; });

    updateGrid();
  }

  function initialiseAll(root = document) {
    root.querySelectorAll('[data-custom-cakes-gallery]').forEach(initialiseGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
